import React from 'react'
import { SvgIcon } from '@material-ui/core'

function DeleteIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        id='Vector'
        d='M10.1334 10.6667V16C10.1334 16.3681 10.4319 16.6667 10.8001 16.6667C11.1683 16.6667 11.4668 16.3681 11.4668 16V10.6667C11.4668 10.2985 11.1683 10 10.8001 10C10.4319 10 10.1334 10.2985 10.1334 10.6667Z'
        fill='#444444'
      />
      <path
        id='Vector_2'
        d='M13.4667 10C13.8349 10 14.1334 10.2985 14.1334 10.6667V16C14.1334 16.3681 13.8349 16.6667 13.4667 16.6667C13.0985 16.6667 12.8 16.3681 12.8 16V10.6667C12.8 10.2985 13.0985 10 13.4667 10Z'
        fill='#444444'
      />
      <path
        id='Vector_3'
        d='M14.8 6.66667H18.8C19.1682 6.66667 19.4667 6.96515 19.4667 7.33333C19.4667 7.70152 19.1682 8 18.8 8H18.0634L17.0595 17.0348C16.8719 18.7229 15.4451 20 13.7466 20H10.5202C8.82166 20 7.39478 18.7229 7.20721 17.0348L6.20334 8H5.46672C5.09853 8 4.80005 7.70152 4.80005 7.33333C4.80005 6.96515 5.09853 6.66667 5.46672 6.66667H9.46672C9.46672 5.19391 10.6606 4 12.1334 4C13.6061 4 14.8 5.19391 14.8 6.66667ZM12.1334 5.33333C11.397 5.33333 10.8 5.93029 10.8 6.66667H13.4667C13.4667 5.93029 12.8698 5.33333 12.1334 5.33333ZM7.54489 8L8.53238 16.8875C8.64493 17.9004 9.50105 18.6667 10.5202 18.6667H13.7466C14.7657 18.6667 15.6218 17.9004 15.7343 16.8875L16.7219 8H7.54489Z'
        fill='#444444'
      />
    </SvgIcon>
  )
}

export default DeleteIcon
